import { Component, OnInit } from '@angular/core';
import { SharedService } from '../_service';

@Component({
  selector: 'order-file',
  template: require('./orders.component.html'),
})

export class OrdersComponent implements OnInit {

  public isMenu = 1;

  public constructor(
    private sharedService: SharedService
  ){
    sharedService.changeEmitted$.subscribe(
      (source) => {
        this.isMenu = source.isMenu;
      });
  }

  public ngOnInit() {
    console.log('orders Component');
  }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/orders/orders.component.ts